import CryptoJS from "crypto-js";


// Use the same key as backend (hash to 32 bytes for AES-256)
const ENCRYPTION_KEY = CryptoJS.SHA256('Alap%432()@!#%$^&*()_+'); 
// Fixed IV (same as backend, 16 bytes)
const IV = CryptoJS.enc.Hex.parse("00000000000000000000000000000000"); 

export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, ENCRYPTION_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

export function decrypt(hexText) {
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(hexText)
  });
  const decrypted = CryptoJS.AES.decrypt(cipherParams, ENCRYPTION_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
